module.exports = __webpack_public_path__ + "img/semi-complete.861b4999.svg";